import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';

export const StyledShipDetailBg = styled.section`
    position: relative;

    h2 {
        font-size: ${(props) => props.theme.fontSize.headlineS};
        font-weight: 600;
        margin-bottom: 10px;
        @media ${mediaQueries.tabletAndUp} {
            font-size: ${(props) => props.theme.fontSize.headlineM};
        }
    }
`;
